import { useCallback, useContext } from 'react';
import {
  useActionItem,
  ActionItemOperation as Operation,
  AiContext,
} from '@workboard/action-item';

export function useRequestFeedback(
  aiId: string | null,
  analyticName: string | null = null
) {
  const { setDisabledEnforceFocus } = useContext(AiContext);
  const { isPermitted, actionItem, refetch } = useActionItem(aiId);
  const canRequestFeedback =
    isPermitted(Operation.requestFeedback) &&
    window.wbConfig?.isEnabledNewFeedback;

  const teamId = actionItem?.workstreamContext?.workstream?.team?.id ?? '';

  const onOpen = useCallback(() => {
    setDisabledEnforceFocus(true);
  }, [setDisabledEnforceFocus]);

  const onClose = useCallback(() => {
    setDisabledEnforceFocus(false);
    refetch();
  }, [setDisabledEnforceFocus, refetch]);

  const sendRequestFeedback = useCallback(() => {
    onOpen();
    window?.openRequestFeedbackModal?.({
      teamId,
      memberId: actionItem?.assignee?.id,
      actId: aiId,
      analyticName,
      onClose,
    });
  }, [aiId, teamId, actionItem?.assignee?.id, onOpen, onClose, analyticName]);

  return [canRequestFeedback, sendRequestFeedback] as const;
}
